module.exports = function getResource(label, vars = []) {
    let resources = {
        pickUpInStore: 'Ramassez en magasin',
        chooseThisStore: 'Choisissez ce magasin',
        notAbleToFind: `Nous n’avons pas été en mesure de trouver un magasin près de « ${vars[0]} ».`,
        differentLocation: 'Veuillez essayer un autre emplacement.',
        ok: 'OK',
        changeStoreTitle: 'Changer de magasin',
        changeStoreMessage: 'Si des articles à ramasser se trouvent dans votre panier, le lieu du ramassage sera modifié pour le magasin',
        anyPromosRewardsMsg: 'De plus, toute promotion ou récompense dans votre panier d’articles à ramasser en sera retirée. Vous pouvez ajouter des promotions et des récompenses en magasin, s’il y a lieu.'
    };

    return resources[label];
};
